<template>
  <div class="app-container">
      <div class="table__page">
        <el-row style="margin-top: 10px;margin-bottom: 20px">
          <el-col :span="6">
            <label style="font-size: 18px">积分异常值设置</label>
          </el-col>
        </el-row>
        <hr style="color: #8b8b8b">
        <el-row style="margin-top: 25px">
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm"></wt-detail-form-section>
        </el-row>
        <el-row style="margin-top: 25px; text-align: center;">
            <el-button type="default" size="small" v-if="isEditFlag" @click="toCancel">取消</el-button>
            <wt-auth :hasAnyPremission="'MODULE_INTEGRALABNORMALVALUE:EDIT'" class="search-form-btn">
              <el-button type="primary" size="small" v-if="!isEditFlag" @click="toEdit">编辑</el-button>
            </wt-auth>
            <el-button type="primary" size="small" v-if="isEditFlag" @click="saveBtn">保存</el-button>
        </el-row>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'integralAbnormalValue',
  data() {
    return {
      isEditFlag: false,
      detailForm: {
        title: '',
        className: 'wt-section-content',
        elements: [
          { name: '投递可回收物异常值', key: '1', type: 'number', disabled: true, required: false },
          { name: '后台充值积分异常值', key: '2', type: 'number', disabled: true, required: false },
          { name: '取消订单积分异常值', key: '3', type: 'number', disabled: true, required: false },
          { name: '异常订单返还异常值', key: '4', type: 'number', disabled: true, required: false },
          { name: '每日任务积分异常值', key: '5', type: 'number', disabled: true, required: false }
        ]
      },
      detailFormData: { 1: '', 2: '', 3: '', 4: '', 5: '' }
    }
  },
  mounted() {
    this.userIntegralRedLineValueList()
  },
  methods: {
    toEdit() {
      for (const item of this.detailForm.elements) {
        item.disabled = false
        item.required = true
      }
      this.isEditFlag = true
    },
    toCancel() {
      for (const item of this.detailForm.elements) {
        item.disabled = true
        item.required = false
      }
      this.isEditFlag = false
      this.userIntegralRedLineValueList()
    },
    saveBtn() {
      const reqData = []
      for (const key in this.detailFormData) {
        reqData.push({ type: key, value: this.detailFormData[key] })
      }
      this.$wtUtil.deleteConfirm(this, `确认提交此次更改吗？`).then(() => {
        request.post('/modules/userIntegralDetails/userIntegralRedLineEdit', reqData).then(res => {
          if (!res) return false
          this.$message({ message: '操作成功', type: 'success' })
          this.toCancel()
        })
      })
    },
    userIntegralRedLineValueList() {
      request.post('/modules/userIntegralDetails/userIntegralRedLineValueList').then(res => {
        if (res.data) {
          for (const item of res.data) {
            if (item.value) {
              this.detailFormData[item.type] = item.value
            }
          }
        }
      })
    }
  }
}
</script>

<style>
</style>
